import './instrument';
import { removeStressAssessmentRole } from '@fukuri-admins/utils/common/cookies';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from './constants';
import { getEnvFeatureFlag } from './utils/getEnvFeatureFlag';
import '@fukuri-admins/ui/layout/reset.scss';

// role-select 画面を経由しない状態では、以前に保存された役割 Cookie が残っていると
// 通常ビルドで実施者向け表示が復活しうるため、起動時に削除する
if (getEnvFeatureFlag().enableStaging && !IS_STRESS_CHECK_IMPLEMENTER_BUILD) {
  removeStressAssessmentRole();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
